<template lang="html">

<el-dialog
    title="提示"
    width="800px"
    class="record-pop"
    :visible.sync="popState">

    <template slot="title">
       <span>历史版本</span>
    </template>

    <div class="dia-content">

      <div class="nav-line">
          <div @click="navChange(1)" :class="['nav-item',{ 'act' : navAct == 1 }]">楼宇</div>
          <div @click="navChange(2)" :class="['nav-item',{ 'act' : navAct == 2 }]">空间</div>
      </div>

      <div class="c-block">

          <recordBuilding :distdata="resdata.industrialSpaceSnapshot" :hidden="navAct !== 1" />
          <recordFloor :distdata="resdata.industrialSpaceFloorSnapshotList" :hidden="navAct !== 2" />

      </div>

    </div>

</el-dialog>

</template>

<script>
import recordBuilding from './recordBuilding';
import recordFloor from './recordFloor';
import { getRecordInfos } from '@/api/industryInfos';
export default {
    components:{
       recordBuilding,
       recordFloor
    },
    data(){
       return{
          navAct:1,
          popState:false,
          resdata:{}
       }
    },
    methods:{
       navChange(inx){
         this.navAct = inx;
      },
       popSet(row){
          this.popState = true;
          getRecordInfos({id:row.industrialSpaceSnapshotId}).then(resp => {
             this.resdata = resp;
          })
       }
    }
}
</script>

<style lang="scss" scoped>

.record-pop{
   .dia-content{
      .nav-line{
         display: flex;
         padding-left: 20px;
         border-bottom: 1px solid #EBEEF5;
         margin-bottom: 10px;
         .nav-item{
               height: 54px;
               font-size: 14px;
               margin: 0 30px;
               display: inline-block;
               line-height: 54px;
               border-bottom: 2px solid white;
               cursor: pointer;
               &.act{
                  color: #409EFF;
                  border-color: #409EFF;
               }
         }
      }
   }
  
}


</style>

<style lang="scss">

.el-dialog__body{
  padding: 0px 20px;
}

</style>



// WEBPACK FOOTER //
// recordPop.vue?a5610e06